import React, { Component } from 'react';

import { bemClasses } from '../../../utils/bem';

import './styles.scss';

import Column from '../../column';
import Dropdown from '../../dropdown';
import Wrapper from '../../wrapper';

class PageHeaderTitle extends Component {
  ALLOWED_MODIFIERS = ['light', 'white', 'large'];

  componentClassNames = () => {
    return bemClasses('page-header__title', this.ALLOWED_MODIFIERS, this.props);
  };

  largeSize = () => {
    if (this.props.fullWidth) {
      return 12;
    }

    let offset = this.props.centered ? 3 : 0;
    return { size: 4, offset: offset };
  };

  renderOptionsDropdown = () => {
    if (this.props.mobileDropdownOptions) {
      return (
        <Dropdown
          options={this.props.mobileDropdownOptions}
          visible={{ xs: true, sm: true, md: true }}
          button
        />
      );
    }
  };

  render = () => {
    return (
      <Column xs={12} lg={this.largeSize()}>
        <Wrapper
          spaceBetween={!this.props.centered}
          center
          middle={this.props.centered}
        >
          <h1 className={this.componentClassNames()}>{this.props.title}</h1>
          {this.renderOptionsDropdown()}
        </Wrapper>
      </Column>
    );
  };
}

export default PageHeaderTitle;
